import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PendingTask  {
    _originalTypeClassName = "zERP.BO.PendingTask";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PendingTask.translate = translateService;
}
this.Notifications = [];
this.Emails = [];
this.OtherAssignees = [];
this.Id = null;
this.DateCreated = null;
this.IsFinished = false;
this.DateResolved = null;
this.Type = null;
this.ClassName = null;
this.ClassId = null;
this.DueDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateCreated:any;
IsFinished:any;
DateResolved:any;
Type:any;
ClassName:any;
ClassId:any;
DueDate:any;
CreatedBy:any;
AssignedTo:any;
AssignedToDepartment:any;
Entity:any;
Notifications:any;
HandledBy:any;
Emails:any;
OtherAssignees:any;
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setAssignedTo = ($this, value) => {
var oldValue = $this.AssignedTo;
$this.AssignedTo = value;
if (value != null) {
}
}
static setAssignedToDepartment = ($this, value) => {
var oldValue = $this.AssignedToDepartment;
$this.AssignedToDepartment = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setNotifications = ($this, items) => {
                if (items == null) items = [];
                if ($this.Notifications == null) $this.Notifications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Notifications.length > 0) {
                    Domain.PendingTask.removeNotifications($this, $this.Notifications[0]);
                }

                Domain.PendingTask.addManyNotifications($this, copyItems);
            }
static addManyNotifications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PendingTask.addNotifications($this, items[i]);
                }
            }
static addNotifications = ($this, item) => {
                if ($this.Notifications == null) $this.Notifications = [];
                if (item == null || $this.Notifications.indexOf(item) > -1) return;
                $this.Notifications.push(item);
if (item.PendingTask != $this) {
Domain.Notification.setPendingTask(item, $this);
}
}
static addRangeNotifications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PendingTask.addNotifications($this, item));
            }
static removeNotifications = ($this, item) => {
                if ($this == null || $this.Notifications == null || $this.Notifications.indexOf(item) === -1) return;
                var _index = $this.Notifications.indexOf(item);
                $this.Notifications.splice(_index, 1);
item.PendingTask = null;
}
static clearNotifications = ($this) => { $this.Notifications = null; }
static setHandledBy = ($this, value) => {
var oldValue = $this.HandledBy;
$this.HandledBy = value;
if (value != null) {
}
}
static setEmails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Emails == null) $this.Emails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Emails.length > 0) {
                    Domain.PendingTask.removeEmails($this, $this.Emails[0]);
                }

                Domain.PendingTask.addManyEmails($this, copyItems);
            }
static addManyEmails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PendingTask.addEmails($this, items[i]);
                }
            }
static addEmails = ($this, item) => {
                if ($this.Emails == null) $this.Emails = [];
                if (item == null || $this.Emails.indexOf(item) > -1) return;
                $this.Emails.push(item);
}
static addRangeEmails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PendingTask.addEmails($this, item));
            }
static removeEmails = ($this, item) => {
                if ($this == null || $this.Emails == null || $this.Emails.indexOf(item) === -1) return;
                var _index = $this.Emails.indexOf(item);
                $this.Emails.splice(_index, 1);
}
static clearEmails = ($this) => { $this.Emails = null; }
static setOtherAssignees = ($this, items) => {
                if (items == null) items = [];
                if ($this.OtherAssignees == null) $this.OtherAssignees = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OtherAssignees.length > 0) {
                    Domain.PendingTask.removeOtherAssignees($this, $this.OtherAssignees[0]);
                }

                Domain.PendingTask.addManyOtherAssignees($this, copyItems);
            }
static addManyOtherAssignees = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PendingTask.addOtherAssignees($this, items[i]);
                }
            }
static addOtherAssignees = ($this, item) => {
                if ($this.OtherAssignees == null) $this.OtherAssignees = [];
                if (item == null || $this.OtherAssignees.indexOf(item) > -1) return;
                $this.OtherAssignees.push(item);
}
static addRangeOtherAssignees = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PendingTask.addOtherAssignees($this, item));
            }
static removeOtherAssignees = ($this, item) => {
                if ($this == null || $this.OtherAssignees == null || $this.OtherAssignees.indexOf(item) === -1) return;
                var _index = $this.OtherAssignees.indexOf(item);
                $this.OtherAssignees.splice(_index, 1);
}
static clearOtherAssignees = ($this) => { $this.OtherAssignees = null; }

static NotifyWithEmail($this: any): any{}
static Resolve($this: any, userAccount: any): any{$this.IsFinished = true;
$this.DateResolved = moment().toDate();
Domain.PendingTask.setHandledBy($this, userAccount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}